import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class EventService {
  get eventId(): number {
    return window['EVENT_ID'];
  }

  get isEventAdmin(): boolean {
    return Number(window['IS_EVENT_ADMIN']) === 1;
  }

  get hasPermission(): boolean {
    return window['HAS_PERMISSION'];
  }

  get isLinkShare(): boolean {
    return window['IS_LINK_SHARE'];
  }
}

interface IEvent {
  client_id: number;
  name: string;
  updated_at: number;
  url: string;
}
